import React from 'react';
import {
  Button,
  Modal,
  ModalFooter,
  ModalHeader,
  ModalSection,
} from '@axiom/ui';
import type { Candidate, Certification } from '@axiom/validation';

import { CandidateApi } from '../../api/candidate-api';
import { CandidateCertificationsApi } from '../../api/candidate-certifications-api';
import { CandidateProfileIssuesApi } from '../../api/candidate-profile-issues-api';

export type AccomplishmentsDeleteModalProps = {
  candidateId: Candidate['id'];
  certificationId: Certification['id'];
  onClose: () => void;
  name?: string;
};

export const AccomplishmentsDeleteModal = ({
  candidateId,
  certificationId,
  onClose,
  name = 'ACCOMPLISHMENTS_DELETE_MODAL',
}: AccomplishmentsDeleteModalProps) => {
  return (
    <Modal name={name}>
      <ModalHeader
        name="ACCOMPLISHMENTS_DELETE_MODAL_HEADER"
        onClose={() => {
          onClose();
        }}
      >
        Delete This Accomplishment
      </ModalHeader>
      <ModalSection>
        Deleting this accomplishment removes it from your Axiom for Talent
        Profile and the bio that Axiom shares with prospective clients.
      </ModalSection>
      <ModalFooter>
        <Button
          variation="outline"
          name="CANCEL"
          onClick={() => {
            onClose();
          }}
        >
          Cancel
        </Button>
        <Button
          name="SUBMIT"
          onClick={async () => {
            await CandidateCertificationsApi.deleteCertification(
              certificationId
            );
            await CandidateApi.refreshCandidate(candidateId);
            await CandidateProfileIssuesApi.refreshCandidateProfileIssues(
              candidateId
            );
            onClose();
          }}
        >
          Delete
        </Button>
      </ModalFooter>
    </Modal>
  );
};
